
export default class VideoScrollingText {
    constructor() {
        console.log('%c👍🏼 Video Scrolling Text', 'color: yellow');
        this.videoScrollingText = document.querySelectorAll('.video-scrolling-text')
    }
    init() {

        this.videoScrollingText.forEach(module => {

            let videoContainer = module.querySelector('.video-scrolling-text__video-wrapper2')

            function handleIntersection(entries) {
       
                entries.forEach(entry => {

                    if (entry.isIntersecting) {
                        if (entry.boundingClientRect.top >= 0) {
                            videoContainer.classList.add('active');
                        }
                    } else {
                        if (entry.boundingClientRect.top >= 0) {
                            videoContainer.classList.remove('active');
                        }
                    }
                  })
              }
            
            function handleH2Intersection(entries) {
             
                entries.forEach((entry, index) => {
                  if (entry.isIntersecting) {
                    entry.target.style.opacity = 1;
                    // entry.target.style.transform = 'scale(1)';
                  } else {
                    entry.target.style.opacity = 0;
                    
                    // entry.target.style.transform = 'scale(0.95)';
                    // console.log('h2 intersection', entries.length, index);
                    if(entries.length-1 === index) {
                      // console.log('LAST h2 intersection');
                    }
                  }
                });
              }
            
            const observer = new IntersectionObserver(handleIntersection, {
                root: null, // Use the viewport as the root
                threshold: 0.2, // Trigger the callback when 50% of the target is visible
              });

            let rootMargin = "-50% 0px 0px 0px";
            if (window.innerWidth > 991 ) {
              rootMargin = "-30% 0px 0px 0px";
            }
    
            const h2Observer = new IntersectionObserver(handleH2Intersection, {
                root: null, // Use the viewport as the root
                rootMargin: rootMargin,
                threshold: 1, 
              });

            observer.observe(module);
            let h2s =  module.querySelectorAll('h2');
            h2s.forEach(h2 => {
                h2.style.opacity = 0;
                h2Observer.observe(h2);
            })   

            
        })
    }

    
}


